/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import type * as protobufType from 'protobufjs/minimal';

import Message, { IMessage, IMessageConstructor } from './message';

import compiledMessages from './compiledmessages';

/**
 * Compresses and decompresses given message to/from the binary format using `Protocol Buffers`.
 */
export default class MessagesCompressor {
	/**
	 * Creates an instance of a specific class from encoded buffer.
	 */
	public static decode<T extends IMessageConstructor>( buffer: Buffer, messageClass: T ): unknown | InstanceType<T> {
		const protobufMessage: protobufType.Type = _getType( messageClass );

		const data: protobufType.Message = protobufMessage.decode( typeof window === 'undefined' ? buffer : new Uint8Array( buffer ) );

		// Copy objects to handle optional values.
		// This is needed because protobuf.js creates getters that return default values on undefined.
		// For example, if the message.foo is a string, `undefined` will be converted to an empty string.
		// Copying objects avoids these conversions.
		return messageClass.fromJSON( { ...data } );
	}

	/**
	 * Compress given message to buffer.
	 */
	public static encode( message: Message ): Buffer {
		const protobufMessage: protobufType.Type = _getType( message.constructor );

		const data: IMessage = message.toJSON();

		const error: string | null = protobufMessage.verify( data );

		if ( error ) {
			throw Error( error );
		}

		return protobufMessage.encode( protobufMessage.create( data ) ).finish() as Buffer;
	}
}

function _getType( classMessage: IMessageConstructor ): protobufType.Type {
	return compiledMessages[ classMessage.DESCRIPTOR_NAME ];
}
